<template>
    <layout v-if="hasAccess">
        <template slot="content">
            <ini-content-title :title="title" icon="facture"></ini-content-title>
            <ini-invoice-list 
                :entries="entries" 
                :title="title">
            </ini-invoice-list>
        </template>
    </layout>
</template>

<script>
    import Layout from '@/layout/Boxed'
    import IniInvoiceList from "@/components/Invoice/List/List"
    import IniContentTitle from "@/components/ContentTitle"

    export default {
        data() {
            return {
                hasAccess: false
            }
        },

        components: {
            "layout": Layout,
            "ini-invoice-list": IniInvoiceList,
            "ini-content-title": IniContentTitle
        },

        beforeMount() {
            this.hasAccess = this.$store.getters.getStructure.access && this.$store.getters.getStructure.access.invoices
        },

        mounted() {
            // Only call fetchList with pagination for Invoice module
            if (this.hasAccess) {
                this.$store.dispatch('fetchList', {
                    module: 'Invoice',
                    page: 1  // Initialize with page 1 to enable pagination state
                })
            }
        },

        computed: {
            entries() {
                let list = this.$store.getters.getList('Invoice')
                if(list && list.entries){
                    return list.entries
                }
                return []
            },
            
            title() {
                return this.$t("LBL_INVOICES")
            }
        }
    }
</script>
